import styled from 'styled-components';

export const Container = styled.div<{ $width?: string; $height?: string }>`
  width: ${({ $width }) => $width || '100%'};
  height: ${({ $height }) => $height || 'auto'};
`;

export const DropdownWrapper = styled.div`
  display: flex;
  align-items: center;

  padding: 0 8px 0 0;
`;
